import "./header.css";

const Header = () => {
  return (
    <header>
      <h1>Glassmorphizm</h1>
      <p>help you to get better design</p>
    </header>
  );
};

export default Header;
